import React from "react"
import { AdversaryNameLink } from "../Filtering/AdversaryNameLink"
import SI, { Play } from "../../Common/SI"

export interface AdversaryOutcomeTableProps {
	plays: Play[]
}

export const AdversaryOutcomeTable = React.memo(function (props: AdversaryOutcomeTableProps): JSX.Element {

	const outcomesByAdversary: Map<string, OutcomeSummary[]> = new Map()
	const playCountByAdversary: Map<string, number> = new Map()

	let maxLevel = 0
	for (const adversary of SI.adversaries) {

		const outcomes: OutcomeSummary[] = adversary.difficulty.map(difficulty => {
			return {
				difficulty,
				lossCount: 0,
				playCount: 0,
				winCount: 0,
				winRate: null,
			}
		})
		outcomesByAdversary.set(adversary.name, outcomes)
		playCountByAdversary.set(adversary.name, 0)
		maxLevel = Math.max(maxLevel, adversary.difficulty.length - 1)
	}

	for (const play of props.plays) {
		if (!SI.isSingleAdversaryNoScenario(play)) {
			continue
		}

		const adversaryLevel = play.adversaries[0]
		const outcomeSummaries = outcomesByAdversary.get(adversaryLevel.name)
		if (!outcomeSummaries || adversaryLevel.level < 0 || adversaryLevel.level > outcomeSummaries.length) {
			continue
		}

		const outcomeSummary = outcomeSummaries[adversaryLevel.level]
		if (play.outcome.victory) {
			outcomeSummary.winCount++
		} else {
			outcomeSummary.lossCount++
		}

		playCountByAdversary.set(adversaryLevel.name, playCountByAdversary.get(adversaryLevel.name)! + 1)
	}

	for (const outcomeSummaries of outcomesByAdversary.values()) {
		for (const outcomeSummary of outcomeSummaries) {
			outcomeSummary.playCount = outcomeSummary.winCount + outcomeSummary.lossCount
			if (outcomeSummary.playCount) {
				outcomeSummary.winRate = outcomeSummary.winCount / outcomeSummary.playCount
			}
		}
	}

	// [0, 1, ...]
	const levels = [...Array(maxLevel + 1).keys()]

	return (
		<div>
			<table className="stats adversary-outcomes">
				<thead>
					<tr>
						<th rowSpan={2}>(Single adversary,<br />no scenario)</th>
						{
							levels.map(level => (
								<th key={level} colSpan={3}>{level}</th>
							))
						}
						<th></th>
					</tr>
					<tr>
						{
							levels.map(level => (
								<React.Fragment key={level}>
									<th>W</th>
									<th>L</th>
									{/* <th>T</th> */}
									<th>Win %</th>
								</React.Fragment>
							))
						}
						<th>Total</th>
					</tr>
				</thead>
				<tbody>
					{
						SI.adversaries.map(adversary => {
							const outcomeSummaries = outcomesByAdversary.get(adversary.name)!
							return (
								<tr key={adversary.name}>
									<th>
										<AdversaryNameLink adversaryName={adversary.name} />
									</th>
									{
										levels.map(level => {
											if (adversary.difficulty.length <= level) {
												// This adversary doesn't go this high
												return (
													<React.Fragment key={level}>
														<td colSpan={3}></td>
													</React.Fragment>
												)
											} else {
												const outcomeSummary = outcomeSummaries[level]
												return (
													<React.Fragment key={level}>
														<td className={`victory difficulty-${adversary.difficulty[level]}`}>
															{outcomeSummary.winCount || ''}
														</td>
														<td className={`loss difficulty-${adversary.difficulty[level]}`}>
															{outcomeSummary.lossCount || ''}
														</td>
														{/* <td className={`difficulty-${adversary.difficulty[level]}`}>
															{outcomeSummary.playCount || ''}
														</td> */}
														<td className={`difficulty-${adversary.difficulty[level]}`}>
															{outcomeSummary.winRate ? `${(100 * outcomeSummary.winRate).toFixed(1)}%` : ''}
														</td>
													</React.Fragment>
												)
											}
										})
									}
									<td>{
										playCountByAdversary.get(adversary.name)
									}</td>
								</tr>
							)
						})
					}
				</tbody>
			</table>
		</div>
	)
})

interface OutcomeSummary {
	difficulty: number
	lossCount: number
	playCount: number
	winCount: number
	winRate: number | null
}
